import { GraphQLError } from 'graphql';
import { useToggleable } from '../hooks';
import { useState } from 'react';
import { FindGroupOrderMutationVariables, FindOrderMutationVariables } from '@websky/graphql';

type SubmitParams = FindGroupOrderMutationVariables | FindOrderMutationVariables;

export const useSecureAccess = () => {
	const { isOpen, close, open } = useToggleable(false);
	const [submitParams, setSubmitParams] = useState<SubmitParams>();

	const [showEror, setShowError] = useState(false);

	// @ts-ignore
	const setSecret2fa = (secret2fa: string) => setSubmitParams(params => ({ params: { ...params, secret2fa } }));

	const isNeedToOpenSecureAccessModal = (errors: GraphQLError[]) => {
		if (!errors?.length) {
			return false;
		}

		return errors.some(responseError => {
			return [responseError.message, responseError['debugMessage']].includes(
				'PNR is locked. Try to unlock with data from e-mail'
			);
		});
	};

	const isFindGroupOrderVariablesGuard = (params: SubmitParams): params is FindGroupOrderMutationVariables => {
		return 'travellersDataForSplit' in (params as FindGroupOrderMutationVariables).params;
	};

	return {
		isOpen,
		open,
		close,
		submitParams,
		setSubmitParams,
		setSecret2fa,
		isNeedToOpenSecureAccessModal,
		isFindGroupOrderVariablesGuard,
		showEror,
		setShowError
	};
};
